import { Box, Text } from '@quintoandar-tokko/jopijs';
import styles from './styles.module.scss';

const STATUSES = {
  ACTIVE: 1,
  SIGNED: 2,
  FALLEN: 3,
};

const STATUSES_TEXT = {
  [STATUSES.ACTIVE]: 'active',
  [STATUSES.SIGNED]: 'signed',
  [STATUSES.FALLEN]: 'fallen',
};

export default function StatusCell({ id, text, ...rest }) {
  const safetyStatusText = STATUSES_TEXT[id] ?? STATUSES_TEXT[STATUSES.FALLEN];

  return (
    <Box className={styles.status} data-status={safetyStatusText} {...rest}>
      <Text className={styles.statusText}>{text}</Text>
    </Box>
  );
}
